/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-12-09 10:26:08
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-09-15 18:09:36
 * @FilePath: /wemeet-web-activity/src/components/HomeHeader/FollowGuide/guidePc.tsx
 * @Description: pc引导动效
 */
import { memo, ReactNode } from 'react';
import { Bubble } from '@tencent/tea-component';
import styles from './index.module.scss';
import Button from '@tencent/tpm-meeting-active/lib/Button';

interface GuidePcProps {
  visible: boolean;
  children: ReactNode;
  handleNoRemind: VoidFunction;
  handleKnowBtn: VoidFunction;
}

const GuidePc = ({ visible, children, handleNoRemind, handleKnowBtn }: GuidePcProps) => (
  <Bubble
    className={styles.webinarEventGuideBubble}
    placement="bottom"
    visible={visible}
    content={
      <div className={styles.webinarEventGuideBox}>
        <h2 className={styles.webinarEventGuideBoxTitle}>查看已关注的主办方及其动态</h2>
        <p className={styles.webinarEventGuideBoxNote}>
          您可以进入“我的 - 活动空间”中，在“
          <a
            href="/events/my/follow"
            target="_blank"
            className={styles.webinarEventGuideBoxSubscribe}
          >
            我的关注
          </a>
          ”中查看关注的主办方及最新动态, 客户端需更新至3.8及以上版本
        </p>
        <div className={styles.webinarEventGuideBoxImg}>
          <img src="https://wemeet-activity-test-1258344699.cos.ap-guangzhou.myqcloud.com/event_guide.gif" />
        </div>
        <div className={styles.webinarEventGuideBoxFooter}>
          <Button
            onClick={handleNoRemind}
            className={`${styles.webinarEventGuideBoxFooterRightBtn} size-s`}
          >
            不再提醒
          </Button>
          <Button
            className={`${styles.webinarEventGuideBoxFooterRightBtn} size-s`}
            type="primary"
            onClick={handleKnowBtn}
          >
            我知道了
          </Button>
        </div>
      </div>
    }
  >
    {children}
  </Bubble>
);

export default memo(GuidePc);
